import {
  FormControlConfig,
  IFormControlConfig,
} from '../eo-base-form-control/eo-base-form-control.model';

export interface IEoDatepickerConfig extends IFormControlConfig {
  type?: 'datepicker';
  datePickerStyleClass?: string;
  showIcon?: boolean;
  icon?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showOnFocus?: boolean;
  showClear?: boolean;
  showButtonBar?: boolean;
  appendTo?: any;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;
}

export class EoDatepickerConfig
  extends FormControlConfig
  implements IEoDatepickerConfig
{
  override type?: 'datepicker';
  datePickerStyleClass?: string;
  showIcon?: boolean;
  icon?: string;
  placeholder?: string;
  loadingPlaceholder?: string;
  showClear?: boolean;
  showOnFocus?: boolean;
  showButtonBar?: boolean;
  appendTo?: any;
  dateFormat?: string;
  minDate?: Date;
  maxDate?: Date;

  constructor();
  constructor(obj: IEoDatepickerConfig);
  constructor(obj?: IEoDatepickerConfig) {
    super(obj as IFormControlConfig);
    this.type = 'datepicker';
    this.datePickerStyleClass = obj?.datePickerStyleClass;
    this.showIcon = obj?.showIcon;
    this.icon = obj?.icon;
    this.placeholder = obj?.placeholder;
    this.loadingPlaceholder = obj?.loadingPlaceholder;
    this.showOnFocus = obj?.showOnFocus;
    this.showClear = obj?.showClear;
    this.showButtonBar = obj?.showButtonBar;
    this.appendTo = obj?.appendTo;
    this.dateFormat = obj?.dateFormat;
    this.minDate = obj?.minDate;
    this.maxDate = obj?.maxDate;
  }
}
